const sentryEvents = {
    CLICK: 'click',
    EVENT: 'event',
};

export default sentryEvents;
